import * as React from 'react';
import autobind from 'autobind-decorator';

import { BrandListDataService } from 'src/app/general/brands/list/brand-list.data';
import { BrandEditorView } from './brand-editor.view';

interface BrandEditorControllerProps {
    value: number | null;
    mode: ControlMode;
    onChanged: (value: BrandSummary | null) => void;
    setBusy(isBusy: boolean);
    label?: string;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
	required?: boolean;
	idAgent?: number;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
}

export class BrandEditorController extends React.Component<BrandEditorControllerProps, any> {
    protected brandDataService: BrandListDataService;

    constructor(props) {
        super(props);
        this.brandDataService = BrandListDataService.make();
    }

    @autobind
    protected brandQuery(q?: string): Promise<QueryResult<BrandSummary>> {
        return new Promise<QueryResult<BrandSummary>>((resolve, reject) => {
            this.props.setBusy(true);
            this.brandDataService.addFilter('isDeleted', 'eq', false);
            this.brandDataService.addSorting('id', 'asc', true);
            this.brandDataService.searchKeywords = q;
            this.brandDataService.load(query => query)
                .then((items) => {
                    this.props.setBusy(false);
                    resolve({
                        items: items,
                        totalCount: this.brandDataService.count
                    });
                });
        });
    }

    render() {
        return (
            <BrandEditorView
                brandRequest={{ query: this.brandQuery, dataSet: this.brandDataService }}
                onGetErrorMessage={this.props.onGetErrorMessage}
                {...this.props}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/brands/parts/brand-editor.controller.tsx